import { assistantOwner, readChatState, writeChatState } from './piAssistantModel.js';
import { sessionStore } from './piNavigation.js';
import { browserStorage } from './piUnlock.js';

let current = null;

let agents = null;

export const chatOwner = () => assistantOwner(browserStorage());

export const chatState = () => {
  const owner = chatOwner();
  if (!current || current.owner !== owner) current = readChatState(sessionStore(), owner);
  return current;
};

export const saveChatState = (state) => {
  current = state;
  writeChatState(sessionStore(), state);
  return current;
};

export const updateChatState = (changes) => saveChatState(Object.assign({}, chatState(), changes || {}));

export const cachedAgents = (owner) => (agents && agents.owner === owner ? agents.envelope : null);

export const keepAgents = (owner, envelope) => {
  agents = envelope ? { owner: owner, envelope: envelope } : null;
};



// WEBPACK FOOTER //
// ./src/vue/pages/components/pi/piChatSession.js